import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import * as Actions from 'actions';
import * as Permissions from 'permissions';
import { connect } from 'react-redux';
import { Container, ClientsColumns, ClientsContainerFooter, ClientsMapViewFooterContainer } from 'components';
import Classnames from 'classnames';
import ClientsFilters from './clients-filters';
import { Modal } from 'react-bootstrap';

class ClientsContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    	filters_shown : true,
    }

    this.displayName = 'ClientsContainer';

    this.postRender = this.postRender.bind(this);
    this.toggleShowFilters = this.toggleShowFilters.bind(this)

    const { pathname } = this.props.routing.locationBeforeTransitions;
    if(!this.props.canvassing && pathname == '/clients/canvassing') {
      this.props.toggleCanvassing(true);
    }
  }

  toggleShowFilters(val) {
  	this.setState({ filters_shown : val })
  }
  postRender() {
    if(this.refs.view) {
      let view = $(this.refs.view);
      let win = $(window);
      let height;

      if(this.footerRef) {
        let footer = $(this.footerRef);
        height = win.height() - view.offset().top - footer.outerHeight();
      }
      else {
        height = win.height() - view.offset().top;
      }

      view.height(height);
    }
  }
  componentWillMount() {
    this.props.fetchFields('Client');
  }
  componentDidMount() {
    this.postRender();

    let width = $('body').prop('clientWidth');
    if(width < 767) {
    	this.props.setClientColumns(['name', 'phone', 'email'])
    }
  }
  componentDidUpdate({types, states, cities}, prevProps) {
    this.postRender();
  }
  componentWillUnmount() {
    this.props.clearClients();
  }
  render() {
    const { clients } = this.props;
    const { pathname } = this.props.routing.locationBeforeTransitions;

    return (
      <Container title='Clients'>
        <div className='clients-container form-verticle '>
          <div ref='view' className='view'>
            {this.props.children || null}
          </div>
          <ClientsContainerFooter footerRef={r => this.footerRef = r} />
        </div>
        <Modal show={this.props.clients.selecting_columns} onHide={this.props.hideSelectingClientColumns}>
          <Modal.Header>
            <h3 className='title'>Choose Visible Columns</h3>
          </Modal.Header>
          <Modal.Body>
            <ClientsColumns />
          </Modal.Body>
          <Modal.Footer>
            <div onClick={this.props.hideSelectingClientColumns} className='btn btn-default pull-right'>Close</div>
          </Modal.Footer>
        </Modal>
      </Container>
    )
  }
}

ClientsContainer.contextTypes = {
  router : PropTypes.object,
}

const mapStateToProps = ({ clients, canvassing, routing }) => ({ clients, canvassing: canvassing.canvassing, routing });

export default connect(mapStateToProps, Actions)(ClientsContainer);



// WEBPACK FOOTER //
// ./src/browser/components/clients/clients-container.js